import { List, Record as record } from 'immutable';

import Split from './Split';
import CheapestSplit from './CheapestSplit';
import { resolveAll } from '../helpers/LinkMapper';
import { JourneyDirections } from '../constants/AppConstants';

const defaults = {
    singles: new List(),
    returns: new List(),
    cheapest: null,
};

class Splits extends record(defaults) {
    static fromJSON(json = {}) {
        return new Splits({
            singles: resolveAll.as(Split)(json.singles || []),
            returns: resolveAll.as(Split)(json.returns || []),
            cheapest: json.cheapest ? CheapestSplit.fromJSON(json.cheapest) : null
        });
    }

    static isStandard (split) {
        return split.isStandard();
    }

    static isFirstClass (split) {
        return split.isFirstClass();
    }

    static isReturn (split) {
        return split.isReturn();
    }

    getAllSplits() {
        return this.singles.concat(this.returns);
    }

    hasSplits() {
        return this.getAllSplits().size > 0;
    }

    getCheapestOutwardSingle() {
        return this.cheapest && this.cheapest.outwardSingle;
    }

    getCheapestInwardSinglePrice() {
        const cheapestInwardSingle = this.getCheapestInwardSingle();
        return cheapestInwardSingle?.totalPrice;
    }

    getCheapestReturn() {
        return this.cheapest && this.cheapest.return;
    }

    getCheapestInwardSingle() {
        return this.cheapest && this.cheapest.inboundSingle;
    }

    getCheapestSinglesPrice() {
        const outward = this.getCheapestOutwardSingle();
        const inward = this.getCheapestInwardSingle();
        return (outward ? outward.totalPrice : 0) + (inward ? inward.totalPrice : 0);
    }

    getCheapestReturnPrice() {
        const ret = this.getCheapestReturn();
        return ret ? ret.totalPrice : 0;
    }

    getCheapestOutwardAny() {
        const singlesPrice = this.getCheapestSinglesPrice() || Infinity;
        const returnsPrice = this.getCheapestReturnPrice() || Infinity;
        if (singlesPrice < returnsPrice) {
            return this.getCheapestOutwardSingle();
        }

        return this.getCheapestReturn();
    }

    getCheapestForDirection (direction) {
        const directionMap = {
            [JourneyDirections.OUTWARD]: this.getCheapestOutwardAny,
            [JourneyDirections.INWARD]: this.getCheapestInwardSingle
        };
        const fn = directionMap[direction];
        if (typeof fn !== 'function') {
            throw new Error(`Unsupported journey direction: ${direction}`);
        }
        return fn.apply(this);
    }

    getCheapestSplit() {
        const all = this.getAllSplits();
        return all.minBy(split => split.totalPrice);
    }

    getCheapestTotalPrice() {
        const cheapestSplit = this.getCheapestSplit();
        return cheapestSplit ? cheapestSplit.totalPrice : 0;
    }
}

export default Splits;
